import { HOMEPAGE } from "../views/home/routes";
import { SUPERVISOR_HOME_PAGE } from "../views/supervisor/routes";
import { DP_PAGE } from "../views/dp/routes";
import { FINANCEIRO_PAGE } from "../views/financeiro/routes";
import { CAMPANHAS_PAGE } from "../views/campanhas/routes";
import { getPrincipalRoleFromToken } from "./authToken";

/**
 * Home do staff pelo PAPEL PRINCIPAL (ADR 0024): quem é DP com Financeiro
 * adicional cai no DP; quem é Financeiro com DP adicional cai no Financeiro.
 *
 * Ponto único usado por `DefaultRedirect`, `LoginPublicRoute`, login e guards de
 * módulo. A `HOMEPAGE` está atrás do `AdminRoute`: papel novo sem home própria
 * aqui cairia no login e geraria loop (aviso do ADR 0004).
 */
export function staffHomeFromToken(token: string | null): string {
  switch (getPrincipalRoleFromToken(token)) {
    case "SUPERVISOR":
    case "SUPERVISOR_DE_CAMPO":
      return SUPERVISOR_HOME_PAGE();
    case "DP":
      return DP_PAGE();
    case "FINANCEIRO":
    case "FINANCEIRO_LEITURA":
      return FINANCEIRO_PAGE();
    case "GESTOR_CAMPANHAS":
      return CAMPANHAS_PAGE();
    default:
      return HOMEPAGE();
  }
}
